export default __webpack_public_path__ + "static/media/atlas-image.f41d943f.png";